import { render, staticRenderFns } from "./FileAttachmentIcon.vue?vue&type=template&id=80e8f0c6"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e8f0c6')) {
      api.createRecord('80e8f0c6', component.options)
    } else {
      api.reload('80e8f0c6', component.options)
    }
    module.hot.accept("./FileAttachmentIcon.vue?vue&type=template&id=80e8f0c6", function () {
      api.rerender('80e8f0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/FileAttachmentIcon.vue"
export default component.exports